import request from "./request";

const AgentService = {
    GetAll: async (context, signal) => {
        return await request.sendRequest(`/agent/all/agents`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/agent/${id}`, context.token, signal);
    },
    GetAgents: async (id, context, signal) => {
        return await request.sendRequest(`/agent/agents/${id}`, context.token, signal);
    },
    GetAgentList: async (id, context, signal) => {
        return await request.sendRequest(`/agent/list/${id}`, context.token, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/agent`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/agent/${id}`, context.token);
    },
};

export default AgentService;
